import React from "react";

import isIntuit from "Intuit/isIntuit";

import { Modal, ModalHeader } from "Cobalt/Modal";
import Button from "Common/Button";
import Header from "Cobalt/Header";

import makeBem from "Utils/makeBem";

const bem = makeBem("FilterModal");

type ModalProps = {
  show: boolean;
  title: string;
  renderFilter: (arg0: any) => React.ReactNode;
  onHide: () => void;
};

const FilterModal = ({ onHide, show, renderFilter, title, ...rest }: ModalProps) => {
  return (
    <Modal show={show} onHide={onHide} className={bem()}>
      <ModalHeader closeButton>
        <Header level={7} mb={0}>
          {title}
        </Header>
      </ModalHeader>
      <div className={bem("modal-body")}>{renderFilter ? renderFilter(rest) : null}</div>
      {isIntuit() ? (
        <div className={bem("modal-button-overlay")}>
          <Button size="medium" className={bem("modal-button-intuit")} onClick={onHide}>
            Done
          </Button>
        </div>
      ) : (
        <Button size="medium" className={bem("modal-button")} onClick={onHide}>
          Done
        </Button>
      )}
    </Modal>
  );
};

export default FilterModal;
